/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ResponsiveBox, {
  Row,
  Col,
  Item,
  Location,
} from "devextreme-react/responsive-box";
import { Link, useHistory } from "react-router-dom";
import { LoadPanel } from "devextreme-react";
import SelectBox from "devextreme-react/select-box";
import { useDispatch, useSelector } from "react-redux";
import PieChartComponent from "../../../components/charts/pie-chart";
import { IsPermisionOidRequired, showPeriod } from "../../../redux/actions";
import { responseMiddleware, responsePeriod } from "../../../redux/reducers";
import GridTemplate from "./GridTemplate";
import "./style.scss";
import { axios } from "../../../common";

export default function DashboardPage() {
  const [data, setData] = useState([]);
  const [periodField, setPeriodField] = useState();
  const history = useHistory();
  const dispatch = useDispatch();
  const { middleware, loading } = useSelector(responseMiddleware);
  const { period } = useSelector(responsePeriod);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    dispatch(showPeriod());
  }, [dispatch]);

  useEffect(() => {}, []);

  const handleGet = async (PeriodOid) => {
    const { data } = await axios.get(`GetDashboard(${PeriodOid._value})`);
    setData(data.dashboardResp);
  };
  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (!ReadState && ReadState !== undefined)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  function screen(width) {
    return width < 700 ? "sm" : "lg";
  }
  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>Dashboard</div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/default" className={"breadcrumb-item"}>
            Default
          </Link>

          <span className={"breadcrumb-item active"}>Dashboard</span>
        </div>
      </div>
      <ResponsiveBox singleColumnScreen="sm" screenByWidth={screen}>
        <Row ratio={1}></Row>
        <Row ratio={2}></Row>
        <Row ratio={1}></Row>

        <Col ratio={1}></Col>
        <Col ratio={2} screen="lg"></Col>
        <Col ratio={1}></Col>
        <Item>
          <Location row={0} col={0} colspan={3} screen="lg"></Location>
          <Location row={0} col={0} colspan={2} screen="sm"></Location>
          <div className="header item">
            <div className={"section"}>
              <div className={"section-body"}>
                <div className={"navbar_menu"}>
                  <span className="name">Period: </span>
                  <SelectBox
                    width="250"
                    dataSource={period}
                    value={periodField}
                    valueExpr="Oid"
                    displayExpr="PeriodName"
                    className="mr-1"
                    onValueChanged={(e) => {
                      setPeriodField(e.value);
                      handleGet(e.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Item>
        <Item>
          <Location row={1} col={1} screen="lg"></Location>
          <Location row={1} col={0} colspan={2} screen="sm"></Location>
          <div className="content item">
            <div className={"section"}>
              <div className={"section-header"}>
                <h3 className={"section-title"}>Average Overtime Hours</h3>
              </div>
              <div className={"section-body"}>
                <div className="pies-container">
                  <PieChartComponent datasource={data.averageOvertimeHours} />
                </div>
              </div>
            </div>
          </div>
        </Item>
        <Item>
          <Location row={1} col={0} screen="lg"></Location>
          <Location row={2} col={0} screen="sm"></Location>
          <div className="left-side-bar item">
            <div className={"section"}>
              <div className={"section-header"}>
                <h3 className={"section-title"}>Total Overtime Hours</h3>
              </div>
              <div className={"section-body"}>
                <GridTemplate dataSource={data.totalOvertimeHours} />
              </div>
            </div>
          </div>
        </Item>
        <Item>
          <Location row={1} col={2} screen="lg"></Location>
          <Location row={2} col={1} screen="sm"></Location>
          <div className="right-side-bar item">
            <div className={"section"}>
              <div className={"section-header"}>
                <h3 className={"section-title"}>Total Working Hours</h3>
              </div>
              <div className={"section-body"}>
                <GridTemplate dataSource={data.totalWorkingHours} />
              </div>
            </div>
          </div>
        </Item>
        <Item>
          <Location row={2} col={2} screen="lg"></Location>
          <Location row={3} col={1} screen="sm"></Location>
          <div className="right-side-bar item">
            <div className={"section"}>
              <div className={"section-header"}>
                <h3 className={"section-title"}>Top 5 Leave Remain</h3>
              </div>
              <div className={"section-body"}>
                <GridTemplate dataSource={data.top5LeaveRemain} />
              </div>
            </div>
          </div>
        </Item>
        <Item>
          <Location row={2} col={1} screen="lg"></Location>
          <Location row={3} col={1} screen="sm"></Location>
          <div className="content item">
            <div className={"section"}>
              <div className={"section-header"}>
                <h3 className={"section-title"}>Top 5 Leave</h3>
              </div>
              <div className={"section-body"}>
                <GridTemplate dataSource={data.top5Leave} />
              </div>
            </div>
          </div>
        </Item>
      </ResponsiveBox>
    </div>
  );
}
